const config = {
    // SERVER_URL: process.env.REACT_APP_SERVER_URL || "http://localhost:5000",
    SERVER_URL: "https://api.marvelousagrisolution.com",
    API_BASE_URL: "https://api.marvelousagrisolution.com/api",
};

export const getImgUrl = (path) => {
    if (!path) return "https://via.placeholder.com/300";
    if (path.startsWith("http") || path.startsWith("data:")) return path;

    // Ensure path starts with / if it's a relative path not starting with http
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${config.SERVER_URL}${cleanPath}`;
};

export default config;
